import { addRasterOverlay, removeRasterOverlay } from '../raster_helpers';

const cyclingId = 'cycling';
const hikingId = 'hiking';
const mtbId = 'mtb';

const addWaymarkedHelper = (map, waymarkedId) => {
  addRasterOverlay(
    map,
    waymarkedId,
    `https://waymarked-${waymarkedId}.alltrails.com/{z}/{x}/{y}`,
    {
      attribution: "<a target='_blank' href='https://http://www.waymarkedtrails.org/'>Waymarked Trails</a>",
      tileSize: 256,
      maxzoom: 16
    },
    {
      paint: {
        'raster-opacity': 0.8
      }
    }
  );
};

const removeWaymarkedHelper = (map, id) => {
  removeRasterOverlay(map, id);
};

const addWaymarkedCycle = map => {
  addWaymarkedHelper(map, cyclingId);
};

const removeWaymarkedCycle = map => {
  removeWaymarkedHelper(map, cyclingId);
};

const addWaymarkedHiking = map => {
  addWaymarkedHelper(map, hikingId);
};

const removeWaymarkedHiking = map => {
  removeWaymarkedHelper(map, hikingId);
};

const addWaymarkedMTB = map => {
  addWaymarkedHelper(map, mtbId);
};

const removeWaymarkedMTB = map => {
  removeWaymarkedHelper(map, mtbId);
};

export { addWaymarkedCycle, addWaymarkedHiking, addWaymarkedMTB, removeWaymarkedCycle, removeWaymarkedHiking, removeWaymarkedMTB };
